export default __webpack_public_path__ + "static/media/alert.04f19b77.svg";